import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { topics } from "@/mocks/topics";

const categories = ["娱乐动态", "社交网络", "商业代言", "网络传闻", "行业风向"];

const icons: Record<string, string> = {
  娱乐动态: "ri-mic-line",
  社交网络: "ri-chat-3-line",
  商业代言: "ri-price-tag-3-line",
  网络传闻: "ri-question-answer-line",
  行业风向: "ri-line-chart-line",
};

export default function CategoryGrid() {
  return (
    <section className="border-y border-background-300 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主题分类"
          title="按事件类型查找追踪"
          description="不同类别采用不同的核查重点：音视频类侧重原始素材，文字类侧重上下文与来源。"
          align="center"
        />
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat) => {
            const count = topics.filter((t) => t.category === cat).length;
            const active = topics.filter((t) => t.category === cat && t.status === "追证中").length;
            return (
              <Link
                key={cat}
                to={`/topics?category=${encodeURIComponent(cat)}`}
                className="group rounded-lg border border-background-300 bg-background-50 p-5 transition-colors hover:border-secondary-400 cursor-pointer"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${icons[cat]} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {cat}
                </h3>
                <p className="mt-1 font-label text-xs text-foreground-500">
                  收录 {count} 起 · 追踪中 {active} 起
                </p>
                <span className="mt-4 inline-flex items-center gap-1 font-label text-xs text-secondary-700 opacity-0 transition-opacity group-hover:opacity-100">
                  进入分类 <i className="ri-arrow-right-line" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}